<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Empty Gas Cylinders</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="7">
            <!-- excel icon -->
            <download-excel
              :data="products"
              :fields="fields"
              name="Products List"
            >
              <v-icon color="green">mdi-file-excel</v-icon>
            </download-excel>
            <!-- end -->
            <!-- start of table -->
            <v-data-table
              :loading="loader"
              loading-text="Loading Products........"
              :items-per-page="pageItems"
              :headers="headers"
              :items="cylindersData"
              :search="search"
            >
              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn color="editIcon" text :to="`/product/${item.id}`" icon
                  ><v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <!-- end -->
              <!-- action template -->
              <template v-slot:item.deleteProduct="{ item }">
                <v-btn color="red" @click="openDeleteModal(item)" text icon
                  ><v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    deleteDialog: false,
    productItem: {},
    loader: false,
    pageItems: 500,
    headers: [
      { text: "Product Name", value: "Name" },
      { text: "Available Qty", value: "AvailableQty" },
    ],
    cylindersData: [],
    fields: {
      Product: "Name",
    },
  }),
  methods: {
    openDeleteModal(data) {
      this.productItem = data;
      this.deleteDialog = true;
    },
    getProducts() {
      this.$store.commit("btnLoader", false);
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("get", `/empty/cylinders`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.cylindersData = res.ResponseData;
            self.loader = false;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    deleteProduct() {
      const data = this.productItem;
      const url = `/delete/product/${this.productItem.id}`;
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            location.reload();
          } else {
            self.loader = false;
            self.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          self.loader = false;
          self.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getProducts();
  },
};
</script>